/* キャンドール 日本語化スクリプト */
(function() {
  'use strict';

  var translations = {
    'Privacy policy': 'プライバシーポリシー',
    'Refund policy': '返品・返金ポリシー',
    'Terms of service': '利用規約',
    'Shipping policy': '配送ポリシー',
    'Legal notice': '特定商取引法に基づく表記',
    'In stock': '在庫あり',
    'Out of stock': '在庫切れ',
    'Price': '価格',
    'Remove': '削除',
    'Availability': '在庫状況',
    'More payment options': 'その他の決済方法',
    'Products': 'すべての商品'
  };

  function translateTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while (node = walker.nextNode()) {
      var text = node.nodeValue.trim();
      if (translations[text]) {
        node.nodeValue = node.nodeValue.replace(text, translations[text]);
      }
    }
  }

  function translatePage() {
    /* ポリシーページ h1 */
    var h1 = document.querySelector('.shopify-policy__title, h1.policy__heading');
    if (!h1) {
      var h1s = document.querySelectorAll('h1');
      for (var i = 0; i < h1s.length; i++) {
        var t = h1s[i].textContent.trim();
        if (translations[t]) {
          h1s[i].textContent = translations[t];
        }
      }
    } else if (translations[h1.textContent.trim()]) {
      h1.textContent = translations[h1.textContent.trim()];
    }

    /* フィルター関連 */
    var filterEls = document.querySelectorAll('.facets__summary, .facets label, .facets span, .active-facets span, .active-facets__button-inner, #More-payment-options-link, .Shopify-payment-button__more-options, [data-shopify="payment-button"] button');
    filterEls.forEach(function(el) {
      var text = el.textContent.trim();
      if (translations[text]) {
        el.textContent = translations[text];
      }
    });

    /* More payment options */
    var payBtns = document.querySelectorAll('.shopify-payment-button__more-options');
    payBtns.forEach(function(btn) {
      if (btn.textContent.trim() === 'More payment options') {
        btn.textContent = 'その他の決済方法';
      }
    });

    /* コレクションページのh1 "Products" */
    var collH1 = document.querySelector('.collection__title h1, h1.collection__title');
    if (collH1 && collH1.textContent.trim() === 'Products') {
      collH1.textContent = 'すべての商品';
    }

    /* 全体のテキストノード翻訳 */
    var targets = document.querySelectorAll('.facets, .active-facets, .shopify-payment-button, .policy-page');
    targets.forEach(function(target) {
      translateTextNodes(target);
    });
  }

  /* 初回実行 */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translatePage);
  } else {
    translatePage();
  }

  /* 動的コンテンツの監視 */
  var observer = new MutationObserver(function(mutations) {
    translatePage();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

/* === 売り切れ商品を一覧の末尾へ回す（カテゴリ/コレクションページ） === */
(function () {
  function isCollection() { return /\/collections\//.test(location.pathname); }

  function isSoldOut(el) {
    var b = el.querySelector ? el.querySelector('.product-badges') : null;
    return !!(b && /売り切れ/.test(b.textContent));
  }

  /* 在庫品の後ろに売り切れが「混在」しているか（並べ替えが必要か）判定 */
  function needsReorder(items) {
    var seenSoldOut = false;
    for (var i = 0; i < items.length; i++) {
      if (isSoldOut(items[i])) { seenSoldOut = true; }
      else if (seenSoldOut) { return true; }
    }
    return false;
  }

  function reorder() {
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.children);
    if (!needsReorder(items)) return; /* 既に整っていれば何もしない（ループ防止） */
    items.filter(isSoldOut).forEach(function (el) { grid.appendChild(el); });
  }

  function run() { if (isCollection()) reorder(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);

  /* フィルター/ページ切替などでグリッドが差し替わった時も再実行（needsReorderガードで無限ループ回避） */
  if (isCollection()) {
    var t;
    var container = document.querySelector('.product-grid-container') || document.querySelector('main') || document.body;
    var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 120); });
    mo.observe(container, { childList: true, subtree: true });
  }
})();
